import { render, staticRenderFns } from "./GofixPABXContainer.vue?vue&type=template&id=1fa54ba0&"
import script from "./GofixPABXContainer.vue?vue&type=script&lang=js&"
export * from "./GofixPABXContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports